export const buildVeiculosLookup = (veiculos) => {
  const lookup = {};
  veiculos.forEach((veiculo) => {
    if (!veiculo?.numeroFrota) {
      return;
    }
    lookup[veiculo.numeroFrota] = {
      placa: veiculo.placa || '',
      segmento: veiculo.segmento || '',
      modelo: veiculo.modelo || ''
    };
  });
  return lookup;
};

export const enriquecerVeiculosVinculo = (vinculos, veiculosLookup) => {
  const lookup = veiculosLookup || {};
  return vinculos.map((vinculo) => {
    const dadosVeiculo = lookup[vinculo.numeroFrota] || {};
    return {
      ...vinculo,
      placa: dadosVeiculo.placa || vinculo.placa || '',
      segmento: dadosVeiculo.segmento || vinculo.segmento || '',
      modelo: dadosVeiculo.modelo || vinculo.modelo || ''
    };
  });
};
